<template>
  <div class="container wc-container">
    <h3 style="margin-bottom:30px;">Registrations</h3>

    <Row :gutter="16">
      <Table
        :loading="loading"
        width="100%"
        height="500"
        border
        :columns="columns"
        :data="attData"
        size="small"
        ref="table"
      ></Table>
    </Row>
    <Button type="primary" @click="exportTable()">
      <Icon type="ios-download-outline"></Icon>Export data
    </Button>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";
import moment from "moment";
export default {
  data() {
    return {
      loading: true,
      columns: [],
      attData: []
    };
  },
  computed: {
    ...mapGetters("webcast", {
      webcast: "getCopy"
    }),
    ...mapGetters("registrations", {
      registrationsInStore: "find"
    })
  },
  methods: {
    ...mapActions("registrations", {
      findRegistrationsAction: "find"
    }),
    ...mapActions("reg-form", {
      findRegFormFields: "find"
    }),
    exportTable() {
      this.$refs.table.exportCsv({
        filename: "registrations.csv"
      });
    },
    tableData() {
      this.findRegistrationsAction({
        query: {
          webcastId: this.webcast._id,
          $sort: { "attData.createdAt": -1 }
        }
      }).then(registrations => {
        // get last row
        let sampleRow = registrations.data[registrations.data.length - 1];

        console.log(sampleRow);

        if (sampleRow.info) {
          _.forEach(sampleRow.info, (value, key) => {
            this.$data.columns.push({
              title: _.capitalize(key),
              key: key,
              width: 160
            });
          });
        }

        this.$data.columns.push(
          {
            title: "Registered At",
            key: "createdAt",
            align: "center",
            minWidth: 200,
            ellipsis: true
          },
          {
            title: "Last Login",
            key: "updatedAt",
            align: "center",
            minWidth: 200,
            ellipsis: true
          }
        );

        /* device info */
        this.$data.columns.push(
          {
            title: "Browser",
            key: "browser",
            align: "left",
            minWidth: 140,
            ellipsis: true
          },
          {
            title: "Type",
            key: "type",
            align: "left",
            minWidth: 140,
            ellipsis: true
          },
          {
            title: "OS",
            key: "os",
            align: "left",
            minWidth: 140,
            ellipsis: true
          },
          {
            title: "IP City",
            key: "ip_city",
            align: "left",
            minWidth: 140,
            ellipsis: true
          },
          {
            title: "IP Country",
            key: "ip_country",
            align: "left",
            minWidth: 140,
            ellipsis: true
          }
        );

        _.forEach(registrations.data, (reg, key) => {
          let regRow = {};

          if (reg.info) {
            _.forEach(reg.info, (value, key) => {
              regRow[key] = value;
            });
          }

          if (reg.device) {
            _.forEach(reg.device, (value, key) => {
              if (key == "city") {
                key = "ip_city";
              }
              regRow[key] = value;
            });
          }

          regRow["createdAt"] = moment(reg.createdAt).format(
            "MM/DD/YYYY hh:mm:ss"
          );
          regRow["updatedAt"] = moment(reg.updatedAt).format(
            "MM/DD/YYYY hh:mm:ss"
          );
          this.attData.push(regRow);
        });

        this.loading = false;
      });
    }
  },
  created() {
    this.tableData();
  }
};
</script>

<style>
</style>
